sponsors = {
	init() {
		var
			self = this;

		//Всплывающее окно выбора спонсора
		$('.js-sponsor:not(.ok)').each(function() {
			var
				$sponsor = $(this),
				id = $(this).attr('data-id');
			
			$sponsor.on('click', function() {
				$('.js-sponsor-input').val(id);

				$.fancybox.close();

				self.loadName(id);
				
			});

			$sponsor.addClass('ok');
		});

		//Поле для ввода ID
		$('.js-sponsor-input:not(.ok)').each(function() {
			var
				$input = $(this);

			$input.on('blur', function() {
				self.loadName($input.val());
			})

			$input.addClass('ok');
		})
	},

	//-------------------------------------------------
	//Загрузить имя спонсора
	loadName(id) {
		var
			path = '/local/templates/planb/components/planb/personal.register/.default/ajax/sponsor.php',
			$buffer = $('<div>'),
			$input = $('.js-sponsor-input');

		$buffer.load(`${path}?id=${id}`, function(response) {
			if (response.trim())
				$('.js-sponsor-place').html(response);

			//Очистить поле спонсора, если введённое значение недоступно
			if ($(response).find('#noresult').length)
				$input.val('');

			$input.trigger('change');
		});
	}
}



$(document).ready(function() {
	sponsors.init();
});